<template>
  <div class="setUser">
    <div class="setUserBox">
      <section class="userImgBox">
        <van-uploader :after-read="afterRead">
          <p class="userImgBoxTitle">{{ $t.settings.profilePhoto }}</p>
          <figure class="imgBox">
            <van-image class="userImg" :src="userData.UserHeadPhoto && imgUrlFilter(userData.UserHeadPhoto)">
              <template v-slot:error>
                <img class="userImg" src="~assets/img/userManage/img_logo@2x.png" />
              </template>
            </van-image>
          </figure>
        </van-uploader>
      </section>

      <section class="userImgBox newUserImgBox" @click="goEditName">
        <p class="userImgBoxTitle">{{ $t.settings.nickname }}</p>
        <p class="userName" v-if="userData.NickName">{{ userData.NickName }}</p>
        <p class="userName" v-else>{{ $t.auth.editName }}</p>
      </section>
      <section class="userImgBox" @click="onCopy(userData.UserName)">
        <p class="userImgBoxTitle">{{ $t.auth.username }}</p>
        <p class="userName">{{ userData.UserName }}</p>
      </section>
      <section class="userImgBox" @click="gotAuth">
        <p class="userImgBoxTitle">{{ $t.authenticationInfo.checkAuth }}</p>
        <p class="userName" v-if="shopAuth">
          <!-- 已认证 -->
          <span v-if="shopAuth.IsShopSubmit == 1 && shopAuth.IsShopCheck == 1" class="greenBox">{{
            $t.authenticationInfo.haveAuth }}</span>
          <!-- 未通过 -->
          <span v-if="shopAuth.IsShopSubmit == 1 && shopAuth.IsShopCheck == -1" class="redBox">{{
            $t.authenticationInfo.reAuth
            }}</span>
          <!-- 未认证 -->
          <span v-if="shopAuth.IsShopCheck == 0 && shopAuth.IsShopSubmit == 0" class="redBox">{{
            $t.authenticationInfo.unAuth
            }}</span>
          <!-- 审核中 -->
          <span v-if="shopAuth.IsShopCheck == 0 && shopAuth.IsShopSubmit == 1" class="yellowBox">{{
            $t.authenticationInfo.onAuth }}</span>
        </p>
      </section>
      <section class="userImgBox" @click="getAddress">
        <p class="userImgBoxTitle">{{ $t.settings.myShippingAddress }}</p>
        <figure class="backBox">
          <img class="backBoxImg" src="~assets/img/userManage/icon_setting_right@2x.png" />
        </figure>
      </section>
      <section class="userImgBox" @click="onShowLanguage">
        <p class="userImgBoxTitle">{{ $t.meta.systemLanguage }}</p>
        <figure class="backBox">
          <img class="backBoxImg" src="~assets/img/userManage/icon_setting_right@2x.png" />
        </figure>
      </section>
      <section class="userImgBox" @click="goTerms">
        <p class="userImgBoxTitle">{{ $t.settings.userTerms }}</p>
        <figure class="backBox">
          <img class="backBoxImg" src="~assets/img/userManage/icon_setting_right@2x.png" />
        </figure>
      </section>
      <section class="userImgBox" @click="goReturnRules">
        <p class="userImgBoxTitle">{{ $t.settings.userRules }}</p>
        <figure class="backBox">
          <img class="backBoxImg" src="~assets/img/userManage/icon_setting_right@2x.png" />
        </figure>
      </section>

      <section class="userImgBox" @click="goAboutUs">
        <p class="userImgBoxTitle">{{ $t.settings.aboutUs }}</p>
        <figure class="backBox">
          <img class="backBoxImg" src="~assets/img/userManage/icon_setting_right@2x.png" />
        </figure>
      </section>

      <section class="userImgBox" @click="goAcountDelete">
        <p class="userImgBoxTitle">{{ $t.settings.accountDelete }}</p>
        <figure class="backBox">
          <img class="backBoxImg" src="~assets/img/userManage/icon_setting_right@2x.png" />
        </figure>
      </section>

      <radio-list :title="$t.meta.systemLanguage" event="showSetUserLanguages" :value="Language" :options="langOptions"
        @onSelect="onSelectLanguage"></radio-list>

      <div class="loginOutBox" @click="loginOut">
        <div class="loginOut">{{ $t.settings.logOut }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Image, Uploader } from "vant";
import { LOG_OUT } from "@/store/mutation-types";
import { mapMutations } from "vuex";
import { SET_AUTH } from "@/store/mutation-types";
import { isAPP, getPlatform } from "@/plugins/environment/type.js";
import RadioList from "@components/radioList/RadioList.vue";

Vue.use(Image).use(Uploader);
export default {
  name: "setUser",
  components: {
    RadioList,
  },
  data() {
    return {
      isApp: isAPP(),
      platform: getPlatform(),
      userData: {},
      shopAuth: {},
      Language: localStorage.getItem("language") || "auto",
      langOptions: [],
    };
  },
  mounted() {
    let shopAuth = JSON.parse(localStorage.getItem("shopAuth"));
    this.shopAuth = shopAuth;
    this.getUserInfo();
  },
  methods: {
    ...mapMutations([LOG_OUT]),
    imgUrlFilter(value) {
      // console.log(value.split("|")[0]);
      return this.$api.formatImageUrl(value);
    },
    onSelectLanguage(value) {
      localStorage.setItem("language", value);
      this.$commonEnv.commonAction(this.$commonEnv.actionType.refresh);
    },
    onShowLanguage() {
      this.langOptions = [
        { text: this.$t.meta.autoLanguage, value: "auto" },
        { text: "中文", value: "zh" },
        { text: "English", value: "en" },
        { text: "العربية", value: "ar" },
      ];
      this.$bus.$emit("showSetUserLanguages", true);
    },
    getUserInfo() {
      this.$commonMethod.showLoading();
      let param = {};
      this.$api.user
        .getUserInfo(param)
        .then((res) => {
          this.userData = res.data;
          this.SET_AUTH({
            ShopId: res.data.ShopId,
            IsShopCheck: res.data.IsShopCheck,
            IsShopSubmit: res.data.IsShopSubmit,
          });
          this.checkAuth(res.data);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.isfirst = false;
          // console.log(error);
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
            status: error.status,
          });
        });
    },
    checkAuth(value) {
      var shopAuth = {};
      shopAuth.IsShopCheck = value.IsShopCheck;
      shopAuth.IsShopSubmit = value.IsShopSubmit;
      localStorage.setItem("shopAuth", null);
      localStorage.setItem("shopAuth", JSON.stringify(shopAuth));
      this.shopAuth = shopAuth;
    },
    gotAuth() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "authentication",
        name: "Authentication",
        query: [],
      });
    },
    getAddress() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "user/shippingAddress",
        name: "shippingAddress",
        query: [],
      });
    },
    goEditName() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "user/editNickname",
        name: "EditNickname",
        query: [],
      });
    },
    loginOut() {
      this.LOG_OUT();
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "home",
        name: "Home",
        query: [],
      });
    },
    changAvatar(uri) {
      let param = {
        UserHeadPhoto: uri,
      };
      this.$api.user
        .EditUserInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.getUserInfo();
        })
        .catch((err) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.copySuccess,
      });
    },
    afterRead(file) {
      var formData = new FormData();
      formData.append("file", file.file);
      this.$commonMethod.showLoading();
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.changAvatar(res.data.DefaultUrl);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
            status: error.status,
          });
        });
    },
    goTerms() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "terms",
        name: "Terms",
        query: [],
      });
    },
    goReturnRules() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "goodsTerms",
        name: "GoodsTerms",
        query: [],
      });
    },
    goAboutUs() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "aboutUs",
        name: "AboutUs",
        query: [],
      });
    },
    goAcountDelete() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "accountDeletion",
        name: "AccountDeletion",
        query: [],
      });
    },
    ...mapMutations([SET_AUTH]),
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";

@mixin publicUser {
  background-color: #ffffff;
  padding: 15px 15px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  border-radius: 8px;
  @include publicFlex;
}

.setUser {
  width: 100%;
  display: inline-block;

  .setUserBox {
    margin: 0 auto;
    width: 95%;

    .userImgBox {
      margin-top: 10px;
      min-height: 70px;

      .van-uploader {
        width: 100%;

        .userImgBoxTitle {
          line-height: 50px;
          display: inline-block;
        }

        .imgBox {
          float: right;
        }

        ::v-deep .van-uploader__input-wrapper {
          width: 100%;
        }
      }

      @include publicUser;

      .userImgBoxTitle {
        font-size: 14px;
        color: #000000;
        margin: 0;
      }

      .imgBox {
        width: 50px;
        height: 50px;
        border-radius: 100%;
        border: 1px solid #c4e6d5;
        margin: 0;

        .userImg {
          width: 100%;
          width: 50px;
          height: 50px;
          border-radius: 100%;
          object-fit: cover;
        }

        ::v-deep .van-image__error {
          border-radius: 100%;
          position: block;
        }

        ::v-deep .van-image__img {
          border-radius: 100%;
          object-fit: cover;
        }
      }

      .backBox {
        width: 15px;
        margin: 0;

        .backBoxImg {
          width: 100%;
        }
      }

      .userName {
        font-size: 14px;
        color: #000000;
        font-weight: bold;
        margin-right: 10px;

        .greenBox {
          color: #01aaa3;
          font-weight: bold;
        }

        .yellowBox {
          color: orange;
          font-weight: bold;
        }

        .redBox {
          color: red;
          font-weight: bold;
        }
      }
    }

    .newUserImgBox {
      padding: 10px 15px;
    }

    .loginOutBox {
      margin: 8% auto;
      width: 92%;

      .loginOut {
        position: relative;
        width: 100%;
        margin: 0 auto;
        border-radius: 3rem;
        padding: 0.8rem 0;
        text-align: center;
        background: linear-gradient(left, #71d283, #01aaa3);
        color: #ffffff;
        font-size: 1rem;
        line-height: 1;
      }
    }
  }
}
</style>
